/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureResourceSummary extends models.TagPostureResourceBase {
    constructor() {
        super();
        this.setDiscriminator("TagPostureResourceSummary");
    }

    getFixupPrototypeFunction() { return TagPostureResourceSummary.fixupPrototype; }

    static newInstance(model: Partial<TagPostureResourceSummary>): TagPostureResourceSummary {
        let obj = Object.assign(new TagPostureResourceSummary(), model);
        TagPostureResourceSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureResourceSummary>): TagPostureResourceSummary {
        if (!model) return null;
        return TagPostureResourceSummary.newInstance(<TagPostureResourceSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureResourceSummary) {
        if (!obj) return;

        models.TagPostureResourceSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureResourceSummary): boolean {
        if (models.TagPostureResourceBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagPostureResourceSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resource_coverage) {
            models.TagPostureResourceCoverage.fixupPrototype(this.resource_coverage);
        }
    }

    /**
     * Whether or not the resource supports remediation
     */
    supports_remediation: boolean;

    /**
     * Resource coverage of the posture
     */
    resource_coverage: models.TagPostureResourceCoverage;

    /**
     * Whether to only return billable/non billable resources)
     */
    is_billable: Array<boolean>;

}
